// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonBatterySpeakerOnColored_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M7.99986 12.9998H11.9998L9.99983 18.9997H7.99986V12.9998Z" fill="#ED5353"/>
  <path d="M25.9996 8.99985H3.99993V22.9996H12.9998V20.9996H5.9999V10.9998H23.9996V12.1717L26.6659 13.1139C27.1252 13.2762 27.5705 13.4681 27.9995 13.6874V11.9998L25.9996 10.9998V8.99985ZM25.9996 17.1611V14.9997C29.4954 16.2351 32 19.5689 32 23.4877 32 27.4065 29.4954 30.7403 25.9996 31.9756V29.8142C28.3648 28.6909 30.0001 26.2803 30.0001 23.4877 30.0001 20.6951 28.3648 18.2845 25.9996 17.1611Z" class="svg-bg"/>
  <path d="M27.9995 23.4882C27.9995 25.124 27.214 26.5764 25.9996 27.4885V19.4879C27.214 20.4001 27.9995 21.8525 27.9995 23.4882Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M18.9997 19.9997H14.9997V26.9995H18.9997L23.9996 29.9995V16.9997L18.9997 19.9997ZM19.5536 21.9996H16.9997V24.9996H19.5536L21.9996 26.4672V20.532L19.5536 21.9996Z" class="svg-bg"/>
</svg>
`;
const _s48IconSvg = html `<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M38 15H8V33H25V31H10V17H36V19.5L38 20.5V23.7473L40 22.4235V19L38 18V15Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M38 26.1406L32 30.1406H27V38.1406H32L38 42.1406V26.1406ZM32.6056 32.1406H29V36.1406H32.6056L36 38.4036V29.8777L32.6056 32.1406Z" class="svg-bg"/>
  <path d="M45 33.9999C45 36.9611 43.3912 39.5464 41 40.9297V43.1679C44.5318 41.6247 47 38.1006 47 33.9999C47 29.8993 44.5318 26.3751 41 24.832V27.0702C43.3912 28.4534 45 31.0388 45 33.9999Z" class="svg-bg"/>
  <path d="M43 34.0004C43 35.6362 42.2144 37.0885 41 38.0007V30C42.2144 30.9122 43 32.3645 43 34.0004Z" class="svg-bg"/>
  <path d="M12 19H18L15 29H12V19Z" fill="#ED5353"/>
</svg>
`;
/**
 * IconCommonBatterySpeakerOnColored is a generated icon component.
 */
let IconCommonBatterySpeakerOnColored = IconCommonBatterySpeakerOnColored_1 = class IconCommonBatterySpeakerOnColored extends IconBaseElement {
    render() {
        return html `${IconCommonBatterySpeakerOnColored_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonBatterySpeakerOnColored.icons = new Map([
    ['s8', _s32IconSvg],
    ['s12', _s32IconSvg],
    ['s16', _s32IconSvg],
    ['s24', _s32IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s48IconSvg],
    ['s48', _s48IconSvg],
    ['s64', _s48IconSvg],
    ['s72', _s48IconSvg],
    ['s80', _s48IconSvg],
]);
IconCommonBatterySpeakerOnColored = IconCommonBatterySpeakerOnColored_1 = __decorate([
    customElement('zui-icon-common-battery-speaker-on-colored')
], IconCommonBatterySpeakerOnColored);
export { IconCommonBatterySpeakerOnColored };
